/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import XcI18next from '@xc/i18next'
import * as toastModal from 'hiya-common/src/components/ToastModal'
import React, {Component, useMemo} from 'react'
import {connect, useDispatch, useSelector} from 'react-redux'
import * as Sentry from '@sentry/react'
import {matchPath} from 'react-router-dom'

import {banWebBounces} from '@xc/hiya-jsbridge'
import Ended from '../pages/ended'
import SaadaIcon from '../assets/favicon-saada.png'
import {EnvActions, hAppEnum, hLanguageEnum} from '../reducers/env'
import MyHelmet from './MyHelmet'
import {Meta} from '../reducers/commonTypes'
// import { Toaster } from "react-hot-toast";
// 自定义Toaster 兼容 ToastModal 与 Toast同时出现
import Toaster from './CustomToaster'
import {Fallback} from './Fallback'
// import {NetworkStatusMonitor} from '../components/NetworkStatus'
import 'core-js'
import './App.scss'

const useLanguage: any = () => {
  const dispatch = useDispatch()
  const lang = useSelector((store: any) => store.env.deviceinfo.h_language)
  return [
    lang,
    (newLang) => {
      dispatch(
        EnvActions.set({
          deviceinfo: {
            h_language: newLang,
          },
        })
      )
    },
  ]
}

// // // 新多语言工具的全局配置
// // // 语言初始化与修改方法的hook
XcI18next.config.useLanguage = useLanguage
// // // https://www.i18next.com/overview/configuration-options
// // // 默认语言英语
XcI18next.config.initOptions.debug = false
XcI18next.config.initOptions.fallbackLng = hLanguageEnum.en

const firstUpperCase = ([first, ...rest]) => first.toUpperCase() + rest.join('')

// 检查路径是否匹配路由模式数组中的任何一个（支持参数路由）
const matchRoutePattern = (path: string, patterns: string[]): boolean => {
  return patterns.some((pattern) => {
    // 如果模式包含参数（如 :type, :id），使用 matchPath 进行匹配
    if (pattern.includes(':')) {
      const match = matchPath(path, {
        path: pattern,
        exact: true,
      })
      return match !== null
    }
    // 否则使用精确匹配
    return path === pattern
  })
}

class App extends Component<{
  h_language: hLanguageEnum
  baseHref: string
  path: string
  h_web_founction_top: number
  otherInfo: any
  h_app: string
  h_av: string
  meta?: Meta
  originalUrl?: string
  host?: string
}> {
  state = {
    client: false,
    isLoadError: false,
  }

  componentDidMount() {
    this.setState({
      client: true,
    })
    // app 级别的公用逻辑可以放到这里
    // 比如白天、夜间模式功能
    // 调用协议禁止IOS回弹
    // window.HiyaJSBridge.callHandler('banWebBounces')
    banWebBounces()
  }

  render() {
    const {h_language, h_app, otherInfo, h_av, children, meta} = this.props
    const isGame =
      this.props.path.startsWith('/game') && this.props.h_web_founction_top > 0

    const isHiya = [hAppEnum.lite, hAppEnum.game, hAppEnum.pro].includes(
      h_app?.toLocaleLowerCase() as any
    )

    let title = 'Saada'
    if (otherInfo?.title) {
      title = firstUpperCase(otherInfo?.title)
    } else if (isHiya) {
      title = 'Hiya'
    } else {
      title = 'Saada'
    }

    return (
      <Sentry.ErrorBoundary
        fallback={<Fallback isLoadError={this.state.isLoadError} />}
        beforeCapture={(scope) => {
          // @ts-ignore-nextline
          const isLoadError = scope?._breadcrumbs?.some((item) => {
            return (
              item?.message?.includes(
                'failed to asynchronously load component'
              ) || item?.message?.includes('ChunkLoadError: Loading')
            )
          })
          this.setState({
            isLoadError,
          })
        }}
      >
        <div className="AppMain">
          {/* 网络状态监控 */}
          {/* this.state.client && <NetworkStatusMonitor /> */}
          {/* 自定义的Helmet */}
          <MyHelmet
            title={title}
            meta={meta}
            baseHref={this.props.baseHref}
            isSaada={!isHiya}
            SaadaIcon={SaadaIcon}
            h_language={h_language}
            client={this.state.client}
            otherInfo={otherInfo}
            isGame={isGame}
            url={
              ENV === 'production'
                ? `https://${this.props.host + this.props.originalUrl}`
                : `http://${this.props.host + this.props.originalUrl}`
            }
          />
          <Toaster
            toastOptions={{
              className: '',
              duration: 3000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
          <div className={toastModal.ToastModalClassName}>
            <div
              style={{
                minHeight: '100.1vh',
              }}
            >
              {this.state.client ? <>{children}</> : ''}
            </div>
          </div>
        </div>
      </Sentry.ErrorBoundary>
    )
  }
}

export default connect((state) => {
  return {
    h_language: state.env.deviceinfo.h_language,
    h_web_founction_top: state.env.deviceinfo.h_web_founction_top,
    baseHref: state.env.baseHref,
    path: state.env.path,
    otherInfo: state.env.otherInfo,
    h_app: state.env.deviceinfo.h_app,
    h_av: state.env.deviceinfo.h_av,
    meta: state.env.meta,
    originalUrl: state.env.originalUrl,
    host: state.env.host,
  }
})(App) as any
